function onCheckLazyVideo() {
    var lazyVideoTags = document.querySelectorAll('video.lazy-video');

    lazyVideoTags.forEach(function (video) {
        var videoSrc = video.getAttribute('src');

        var videoDesktop = video.getAttribute('data-desktop');
        var videoMobile = video.getAttribute('data-mobile');

        if (window.innerWidth < 768 && videoSrc != videoMobile) {
            video.src = videoMobile;
        } else if (window.innerWidth >= 768 && videoSrc != videoDesktop) {
            video.src = videoDesktop;
        }
    });
}

window.addEventListener('resize', onCheckLazyVideo);
onCheckLazyVideo();
